import React from 'react';
import {decodePolyline} from '../Util'
import * as d3 from "d3";

import Basemap from './Basemap'

class SingleMap extends React.Component {

    componentDidMount(){	   
		
		if (this.props.activity) {
			this.display(this.props.activity);
		}
	
    }

	display(activity) {
		
		var featureCollection = { type: "FeatureCollection",
			features: []
		}
	
		if(activity.map.summary_polyline){
			var feature = {
				type: "Feature",
				properties: {},
				geometry: {
					type: "LineString",
					coordinates: decodePolyline(activity.map.polyline).map(function (elt) { return [elt[1], elt[0]] })
				}
			};
			featureCollection.features.push(feature);
		}

		var projection = d3.geoMercator().fitExtent([[this.props.poster.layout.margin, this.props.poster.layout.margin], [this.props.poster.layout.width-this.props.poster.layout.margin, this.props.poster.layout.height-this.props.poster.layout.margin-this.props.poster.legend.height-this.props.poster.legend.spacer]], featureCollection);

		var path = this.path = d3.geoPath().projection(projection);
		d3.select('#path').datum(featureCollection).attr('d', path);
	
	}

    shouldComponentUpdate(nextProps) {
		if (!this.props.activity && nextProps.activity) {
			this.display(nextProps.activity);
		}
		if (this.props.activity && nextProps.activity) {
			if(this.props.activity.id===nextProps.activity.id && this.props.poster.unit === nextProps.poster.unit){
				return false;
			}
			this.display(nextProps.activity);
		}
		return true;
	}

    render() {
		console.log(this.props);
        

        return (
			<g>
				<Basemap activities={this.props.activity?[this.props.activity]:[]} poster={this.props.poster} offset={0}/>
				<defs>
					<marker id="start" markerWidth="6" markerHeight="6" refX="3" refY="3"
							markerUnits="strokeWidth">
						<circle id="extremity" cx="3" cy="3" r="1"
								fill={this.props.poster.style.route.color} stroke={this.props.poster.style.route.color} stroke-width="1"/>
					</marker>
				</defs>
				<path id='path' marker-start='url(#start)' marker-end='url(#start)' stroke-linejoin="round" strokeWidth={this.props.poster.style.route.strokeWidth} fill='none' stroke={this.props.poster.style.route.color} />
			</g>
        )
    }
}

export default SingleMap;


// WEBPACK FOOTER //
// ./src/components/SingleMap.js